const ocrFillReducer = (state = {}, action) => {
    switch (action.type) {
        case 'UPLOAD_OCR_FILL_DOCUMENT':
            return Object.assign({}, state, {
                data: null,
                isLoading: true,
                error: false,
                errorMessage: null
            });
        case 'DONE_UPLOAD_OCR_FILL_DOCUMENT':
            return Object.assign({}, state, {
                data: action.data,
                isLoading: false,
                error: false,
                errorMessage: null
            });
        case 'ERROR_UPLOAD_OCR_FILL_DOCUMENT':
            return Object.assign({}, state, {
                data: null,
                isLoading: false,
                error: true,
                errorMessage: action.data
            });
        default:
            return state;
    }
}

export default ocrFillReducer;